module.exports = __webpack_public_path__ + "static/media/usdt.0bab137e.svg";